import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {ApiService} from "../services/api.service";
import {ObjectStatus} from "../object-status";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Subscription} from "rxjs";

export interface User {
  Username: string,
  UserCreateDate: string,
  UserLastModifiedDate: string
}

@Component({
  selector: 'app-authorize',
  templateUrl: './authorize.component.html',
  styleUrls: ['./authorize.component.css']
})
export class AuthorizeComponent implements OnInit {

  email = new UntypedFormControl('');
  response = ""

  constructor(private apiService: ApiService) { }
  users: User[] = [];
  // @ts-ignore
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = [
    "Username",
    "UserCreateDate",
    "AuthorizedEndDate",
    "UserStatus",
    "buttons"
  ];
  dataSource = new MatTableDataSource<User>();

  flag_loader = true;
  statusSubscription: Subscription | null = null

  ngOnInit(): void {
    this.load()
  }

  authorize() {
    this.apiService.authorizeExternalUser({authorized_email: this.email.value}).subscribe(
      (res: any) => {
        this.response = res.message
        this.email.reset()
        this.load()
      }
    )
  }

  load() {
    this.statusSubscription = this.apiService.getAuthorizedExternalUser().subscribe(
      (result: User[]) => {
        this.users = result;
        this.flag_loader = false
        this.dataSource.data = this.users;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  removeAuthorization(email: any) {
    this.statusSubscription = this.apiService.removeAccessExternalUser(email).subscribe(
      (result: any) => {
        this.load();
        this.response = result.message
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getAttribute(user: any, attributeName: string) {
    return user.Attributes.find((attribute: any) => {
      return attribute["Name"] == attributeName;
    })["Value"]
  }
}
